import api from '../api'

export async function getNotifications(params?: {
  type?: string
  is_read?: boolean
  page?: number
  page_size?: number
}) {
  const res = await api.get('/notifications/', { params })
  return res.data
}

export async function getAdminNotifications(params?: {
  employee?: string
  type?: string
  is_read?: boolean
  search?: string
  page?: number
  page_size?: number
}) {
  const res = await api.get('/notifications/employees/', { params })
  return res.data
}

export async function markNotificationRead(id: string) {
  const res = await api.patch(`/notifications/${id}/read/`)
  return res.data
}

export async function markAllNotificationsRead() {
  const res = await api.post('/notifications/read-all/')
  return res.data
}

export async function completeNotification(id: string) {
  const res = await api.patch(`/notifications/${id}/complete/`)
  return res.data
}

/**
 * Remove one notification from the home page. Stored notifications are identified by
 * `id`; dynamic ones (recomputed server-side, so they arrive with `id: null`) by their
 * type and the object they point at.
 */
export async function dismissNotification(payload: {
  id?: string | null
  type?: string
  related_object_id?: string | null
}) {
  const res = await api.post('/notifications/dismiss/', payload)
  return res.data
}

export async function dismissAllNotifications() {
  const res = await api.post('/notifications/dismiss-all/')
  return res.data
}
